/* eslint-disable no-console */
import {ReloadOutlined} from '@ant-design/icons';
import {Button, Flex, Select} from 'antd';
import React, {useEffect, useState} from 'react';

import Loader from '../../../../components/Loader/Loader';
import activityPerformance from '../../../../services/modules/DASHBOARD/activityPerformance';
import emissionCalculation from '../../../../services/modules/DASHBOARD/emissionCalculation';
// import listOfActivity from '../../../../services/modules/DASHBOARD/listOfActivity';
import listOfActivity from '../../../../services/modules/DASHBOARD/listOfActivity';
import country from '../../../../services/modules/JSON/country';
import statesJSON from '../../../../services/modules/JSON/statesJSON';
import {yearSelect} from '../../../../utils/FormUtils/yearSelect';

import ActivityPerformance from './ActivityPerformance';
import ListOfActivities from './ListOfActivities';

const Metrics: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [selectedYear, setSelectedYear] = useState(yearSelect()[0].value);
  const [activityData, setActivityData] = useState<any>([]);
  const [listData, setListData] = useState<any>([]);
  const [refresing, setRefresing] = useState<boolean>();
  const [refreshPage, setRefreshPage] = useState(false);

  useEffect(() => {
    if (selectedYear) {
      setIsLoading(true);
      Promise.all([
        activityPerformance(selectedYear),
        listOfActivity(selectedYear),
        country(),
        statesJSON()
      ])
        .then(([activity, list]) => {
          setActivityData(activity);
          setListData(list?.data);
        })
        .catch(() => {})
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [selectedYear, refreshPage]);

  const handleRefreshClick =() =>{
    setRefresing(true);
    Promise.all([
        emissionCalculation(selectedYear)
      ])
      .then(() => {
          setRefreshPage(!refreshPage);
        })
        .catch(() => {})
        .finally(() => {
          setRefresing(false);
        });
  };

  return (
    <Flex className="metricsMainContainer">
      <Flex justify="space-between" align="center" style={{width: '100%'}}>
      <div style={{marginBottom: '10px'}}>
        <Select
          placeholder={'Select Year'}
          defaultValue={selectedYear}
          className="LAselect"
          onChange={(value) => {
            setSelectedYear(value);
          }}
          disabled={isLoading}
          // defaultActiveFirstOption={true}
          options={yearSelect()}
        />
      </div>
      <Button
          type="default"
          icon={<ReloadOutlined />}
          style={{marginBottom: '10px'}}
          title='Reflecting data from Carbon Accounting'
          loading={refresing}
          onClick={()=> {
            handleRefreshClick();
          }}
          >
      </Button>
      </Flex>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <div>
            <ActivityPerformance data={activityData} />
          </div>
          <div>
            <ListOfActivities data={listData} />
          </div>
        </>
      )}
    </Flex>
  );
};

export default Metrics;
